var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContext, useContext, useEffect, useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { createLoadFn } from '../Form/utils';
import { CountryCode } from '../../types';
export var boVehicleDetailsFormDataDefaultValue = {
    countryCode: undefined,
    values: {
        years: [],
        assetTypes: [],
        makes: [],
        models: [],
        options: [],
        states: [],
    },
    load: {
        years: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        assetTypes: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        makes: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        models: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        options: undefined,
        states: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
    },
    loading: {
        years: false,
        assetTypes: false,
        makes: false,
        models: false,
        options: false,
        states: false,
    },
};
export var BOVehicleDetailsFormContext = createContext(boVehicleDetailsFormDataDefaultValue);
export var useBOVehicleDetailsFormContextValue = function (params) {
    var countryCode = params.countryCode, fetchYears = params.fetchYears, fetchAssetTypes = params.fetchAssetTypes, fetchMakes = params.fetchMakes, fetchModels = params.fetchModels, fetchOptions = params.fetchOptions, fetchStates = params.fetchStates;
    var _a = useState([]), years = _a[0], setYears = _a[1];
    var _b = useState([]), assetTypes = _b[0], setAssetTypes = _b[1];
    var _c = useState([]), makes = _c[0], setMakes = _c[1];
    var _d = useState([]), models = _d[0], setModels = _d[1];
    var _e = useState([]), options = _e[0], setOptions = _e[1];
    var _f = useState([]), states = _f[0], setStates = _f[1];
    var _g = useState(false), loadingYears = _g[0], setLoadingYears = _g[1];
    var _h = useState(false), loadingAssetTypes = _h[0], setLoadingAssetTypes = _h[1];
    var _j = useState(false), loadingMakes = _j[0], setLoadingMakes = _j[1];
    var _k = useState(false), loadingModels = _k[0], setLoadingModels = _k[1];
    var _l = useState(false), loadingOptions = _l[0], setLoadingOptions = _l[1];
    var _m = useState(false), loadingStates = _m[0], setLoadingStates = _m[1];
    var countryParam = {
        country_code: countryCode !== null && countryCode !== void 0 ? countryCode : CountryCode.US,
    };
    var loadYears = createLoadFn(fetchYears, setYears, setLoadingYears, countryParam);
    var loadAssetTypes = createLoadFn(fetchAssetTypes, setAssetTypes, setLoadingAssetTypes, countryParam);
    var loadMakes = createLoadFn(fetchMakes, setMakes, setLoadingMakes, countryParam);
    var loadModels = createLoadFn(fetchModels, setModels, setLoadingModels, countryParam);
    var loadOptions = fetchOptions ? createLoadFn(fetchOptions, setOptions, setLoadingOptions, countryParam) : undefined;
    var loadStates = createLoadFn(fetchStates, setStates, setLoadingStates, countryParam);
    useEffect(function () {
        loadYears(countryParam);
        loadAssetTypes(countryParam);
        loadStates(countryParam);
    }, []);
    var t = useTranslation().t;
    var translateSelectOptions = (function (selectOptions) { return selectOptions.map(function (opt) { return (__assign(__assign({}, opt), { label: t(opt.label) })); }); });
    return {
        countryCode: countryCode,
        values: {
            years: years,
            assetTypes: translateSelectOptions(assetTypes),
            makes: makes,
            models: translateSelectOptions(models),
            options: translateSelectOptions(options),
            states: states,
        },
        load: {
            years: loadYears,
            assetTypes: loadAssetTypes,
            makes: loadMakes,
            models: loadModels,
            options: loadOptions,
            states: loadStates,
        },
        loading: {
            years: loadingYears,
            assetTypes: loadingAssetTypes,
            makes: loadingMakes,
            models: loadingModels,
            options: loadingOptions,
            states: loadingStates,
        },
    };
};
export var useBOVehicleDetailsFormContext = function () {
    var boVehicleDetailsFormContext = useContext(BOVehicleDetailsFormContext);
    if (!boVehicleDetailsFormContext) {
        throw new Error('useBOVehicleDetailsFormContext must be used within BOVehicleDetailsFormContext.Provider');
    }
    return boVehicleDetailsFormContext;
};
//# sourceMappingURL=BOVehicleDetailsFormContext.js.map